// extracted by mini-css-extract-plugin
export default {"main":"Retrieval_main__y76WZ"};